webpackJsonp([67332574757204],{

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(204);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivacyPage = function PrivacyPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container-center' },
	    _react2.default.createElement(
	      'h1',
	      { style: { textAlign: 'center' } },
	      'Polityka Prywatno\u015Bci'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Wyra\u017Cam zgod\u0119 na przetwarzanie moich danych osobowych w celu udzielenia odpowiedzi na zadane pytanie.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Administratorem Danych Osobowych (Administratorem) jest M@RCO US\u0141UGI INFORMATYCZNE MAREK KRUPA, ul. Zamkowa 30, 47-451 Twork\xF3w, e-mail: ',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:biuro@twojabi.net' },
	        'biuro@twojabi.net'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Podane w formularzu dane osobowe b\u0119d\u0105 przetwarzane wy\u0142\u0105cznie w celu skontaktowania si\u0119 i udzielenia odpowiedzi na zadane pytanie. Dane b\u0119d\u0105 przechowywane przez okres potrzebny do udzielenia odpowiedzi. Po udzieleniu odpowiedzi dane mog\u0105 by\u0107 przechowywane przez d\u0142u\u017Cszy okres je\u017Celi b\u0119dzie to wymagane przez przepisy prawa lub b\u0119dzie potrzebne do realizowania interesu publicznego.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Po przes\u0142aniu nam swoich danych masz prawo dost\u0119pu do tre\u015Bci swoich danych, ich sprostowania, usuni\u0119cia, ograniczenia przetwarzania, prawo do przenoszenia danych, prawo do wniesienia sprzeciwu, prawo do cofni\u0119cia zgody w dowolnym momencie. Masz r\xF3wnie\u017C prawo do wniesienia skargi do Prezesa Urz\u0119du Ochrony Danych, je\u017Celi uznasz, \u017Ce przetwarzanie Twoich danych osobowych narusza przepisy og\xF3lnego rozporz\u0105dzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 roku. Dane b\u0119d\u0105 przekazywane innym odbiorcom wy\u0142\u0105cznie w przypadku wyst\u0105pienia obowi\u0105zku prawnego.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/', style: { fontSize: 13, color: '#428bca' } },
	      'Wr\xF3\u0107 do strony g\u0142\xF3wnej'
	    )
	  );
	};
	
	exports.default = PrivacyPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-polityka-prywatnosci-js-3f5124fa1b81412d13be.js